import { useRef, useCallback } from 'react';

const useSwipeGesture = ({ onSwipeLeft, onSwipeRight, threshold = 50 }) => {
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const onTouchStart = useCallback((e) => {
    touchStartX.current = e?.touches?.[0]?.clientX;
    touchStartY.current = e?.touches?.[0]?.clientY;
  }, []);

  const onTouchEnd = useCallback((e) => {
    if (touchStartX?.current === null) return;

    const deltaX = e?.changedTouches?.[0]?.clientX - touchStartX?.current;
    const deltaY = e?.changedTouches?.[0]?.clientY - touchStartY?.current;

    // Only trigger horizontal swipe if horizontal movement dominates
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
      if (deltaX < 0) {
        onSwipeLeft?.();
      } else {
        onSwipeRight?.();
      }
    }

    touchStartX.current = null;
    touchStartY.current = null;
  }, [onSwipeLeft, onSwipeRight, threshold]);

  return { onTouchStart, onTouchEnd };
};

export default useSwipeGesture;
